<template>
  <v-dialog
    @click:outside="$emit('close')"
    max-width="1000"
    v-model="show"
    :persistent="report"
    :fullscreen="$vuetify.breakpoint.mobile"
    style="z-index: 999999;"
  >
    <CreateFilter
      :show="show"
      :loading="loading"
      :report="report"
      @close="$emit('close')"
      @search="$emit('search', $event)"
      @save="$emit('save', $event)"
      @input="$emit('input', $event)"
    />
  </v-dialog>
</template>

<script>
import CreateFilter from './CreateFilter.vue'

export default {
  components: {
    CreateFilter
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    report: {
      type: Boolean,
      default: false
    }
  }
}
</script>